import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/internal/operators/map";
import { Aggregator, AggregatorByType } from "src/app/models/aggregator/aggregator";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
  })

export class AggregatorService {
    baseUrl = environment.Base_URL
    constructor(private http :HttpClient) {}

    getAggregators(data):Observable<any[]>{
        var quersytring = ''

        if(data.AggregatorCode){
            quersytring += 'AggregatorCode='+data.AggregatorCode +'&'
        }
        if(data.AggregatorName !== ''){
            quersytring += 'AggregatorName='+data.AggregatorName +'&'
        }
        if(data.AggreatorType ! == ''){
            quersytring +='AggreatorType='+data.AggreatorType +'&'
        }
        if(quersytring !== ''){
            return this.http.get<Aggregator[]>(this.baseUrl+`Aggregation/GetAllAggregatorHeirarchyData/${data.Status}/${data.AggregatorCode}/${data.page}/${data.pageSize}?AggregatorType=${data.AggreatorType}&AggregatorName=${data.AggregatorName}`)
           
        }else{
            return this.http.get<Aggregator[]>(this.baseUrl+`Aggregation/GetAllAggregatorHeirarchyData/${data.AggregatorCode}/${data.page}/${data.pageSize}`)
        }
        
    }

    deleteAggregator(id):Observable<any>{
        return this.http.put(this.baseUrl +'Aggregation/DeleteAggregatorData' ,id, {observe: 'response'})
    }

    rejectAggregator(id):Observable<any>{
        return this.http.put(this.baseUrl +'Aggregation/RejectAggregatorData' ,id, {observe: 'response'})
    }

    sendAggregatorToPending(id):Observable<any>{
        return this.http.put(this.baseUrl +'Aggregation/SendAggregatorToPending' ,id, {observe: 'response'})
    }

    approveAggregator(obj):Observable<any>{
        return this.http.put(this.baseUrl +'Aggregation/ApproveAggregatorData_V_1_0_1' ,obj, {observe: 'response'})
    }

    getAggregatorByType(code,type):Observable<AggregatorByType[]>{
        if(type == 'DSA'){
            return this.http.get<AggregatorByType[]>(this.baseUrl+ `Aggregation/GetAllAggregatorDropDown_Hirarchy/${code}?AggregatorType=DSA&AggregatorType=FPO`)
            .pipe(map((data:AggregatorByType[]) => {
                const transformedData = data;
                return transformedData
            }))
        }else{
            return this.http.get<AggregatorByType[]>(this.baseUrl+ `Aggregation/GetAllAggregatorDropDown_Hirarchy/${code}?AggregatorType=${type}`)
            .pipe(map((data:AggregatorByType[]) => {
                const transformedData = data;
                return transformedData
            }))
        }
        
    }

    uploadAggregatorCSV(data):Observable<any>{
        return this.http.post<any>(this.baseUrl+'Aggregation/AddAggregatorDataList',data, { observe:'response'})
    }

    addAggregatorData(userData):Observable<Aggregator>{
        return this.http.post<Aggregator>(this.baseUrl+'Aggregation/AddAggregatorDataForAdmin',userData)
        .pipe(map((data:Aggregator) => {
            const transformedData = data
            return transformedData
        }))
    }

    updateAggregator(userData):Observable<Aggregator>{
        return this.http.put(this.baseUrl+'Aggregation/UpdateAggregatorData',userData,)
        .pipe(map((data:Aggregator) => {
            const transformedData = data
            return transformedData
        }));
    }

    getAggregatorSearchContent(code,val):Observable<any>{
     return this.http.get(this.baseUrl+`Aggregation/GetAllAggregatorDropDown_Hirarchy/${code}?AggregatorName=${val}`) 
    }

    getHTMLtemplate(id){
        return this.http.get(this.baseUrl+'Aggregation/GetMOUHtmlForShow/'+id,{responseType: 'text'}) 
    }
}